import { useQueryClient } from '@tanstack/react-query';
import {
  getGetApiV5FilesPendingReviewQueryKey,
  usePutApiV5FilesIdMarkAsReviewed,
} from 'api/v5/files/files';
import ConfirmationModal from 'common/ConfirmationModal';

export interface MarkAsReviewedConfirmationModalProps {
  fileUuid: string;
  isOpen: boolean;
  onClose: () => void;
}

export const MarkAsReviewedConfirmationModal = ({
  fileUuid,
  isOpen,
  onClose,
}: MarkAsReviewedConfirmationModalProps) => {
  const queryClient = useQueryClient();

  const { mutateAsync: markAsReviewed, isLoading } =
    usePutApiV5FilesIdMarkAsReviewed();

  const handleMarkAsReviewed = async () => {
    await markAsReviewed({ id: fileUuid }).catch(() => {});
    // Invalidate the pending review query to refresh the file list
    queryClient.removeQueries({
      queryKey: getGetApiV5FilesPendingReviewQueryKey(),
    });
    onClose();
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      headerText="Confirm mark as reviewed"
      messageText="Do you want to mark this file as reviewed?"
      noBtnClick={onClose}
      yesBtnClick={handleMarkAsReviewed}
      yesBtnText="Yes, mark as reviewed"
      noBtnText="No"
      disableYesBtn={isLoading}
      disableNoBtn={isLoading}
    />
  );
};
